import React, { useId } from "react";
import { TIPOS_DOCUMENTO_ESTRANGEIRO, limparNumeroEstrangeiro, limparPaisEstrangeiro } from "../utils/documentoEstrangeiro";

/**
 * Versão em HTML simples (telas sem MUI) do flag "<Cadastro> estrangeiro" + campos do
 * documento estrangeiro. Mesmas props do DocumentoEstrangeiroCampos; `classeCampo`
 * recebe a classe CSS dos campos da tela e `estiloSelect` o estilo dos <select>.
 * `tipoPessoa`/`onTipoPessoa` (opcionais) mostram o seletor PF/PJ para estrangeiro sem CPF/CNPJ.
 */
export default function DocumentoEstrangeiroCamposHtml({
  valor = {},
  onChange,
  somenteLeitura = false,
  classeCampo = "campo-formulario-padrao",
  classeLinha = "linha-dupla",
  estiloSelect,
  rotuloFlag = "Estrangeiro",
  obrigatorio = true,
  mostrarFlag = true,
  mostrarTipoPessoa = false,
  tipoPessoa = "",
  onTipoPessoa,
  opcoesTipoPessoa = [
    { valor: "PF", label: "Pessoa Física" },
    { valor: "PJ", label: "Pessoa Jurídica" },
  ],
}) {
  const alterar = (campo, v) => {
    if (!somenteLeitura) onChange?.(campo, v);
  };
  if (!mostrarFlag && !valor.estrangeiro) return null;
  // Com CPF/CNPJ informado o documento estrangeiro é opcional (sem asterisco).
  const ast = obrigatorio ? "*" : "";
  const estiloOpcao = estiloSelect ? { backgroundColor: estiloSelect.backgroundColor, color: estiloSelect.color } : undefined;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 8 }}>
      {mostrarFlag && <FlagEstrangeiroHtml valor={valor} onChange={onChange} somenteLeitura={somenteLeitura} rotulo={rotuloFlag} />}

      {valor.estrangeiro && (
        <div className={classeLinha} style={{ display: "flex", gap: 12, alignItems: "flex-end", flexWrap: "wrap" }}>
          <div style={{ flex: "1 1 200px" }}>
            <label>{`Tipo de documento${ast}`}</label>
            <select
              value={valor.documentoEstrangeiroTipo || ""}
              onChange={(e) => alterar("documentoEstrangeiroTipo", e.target.value)}
              disabled={somenteLeitura}
              className={classeCampo}
              style={estiloSelect}
            >
              <option value="" style={estiloOpcao}>
                Selecione
              </option>
              {TIPOS_DOCUMENTO_ESTRANGEIRO.map((t) => (
                <option key={t.valor} value={t.valor} style={estiloOpcao}>
                  {t.label}
                </option>
              ))}
            </select>
          </div>
          <div style={{ flex: "1 1 200px" }}>
            <label>{`Nº do documento${ast}`}</label>
            <input
              value={valor.documentoEstrangeiroNumero || ""}
              onChange={(e) => alterar("documentoEstrangeiroNumero", limparNumeroEstrangeiro(e.target.value))}
              disabled={somenteLeitura}
              maxLength={50}
              placeholder="Letras e números"
              className={classeCampo}
            />
          </div>
          <div style={{ flex: "1 1 180px" }}>
            <label>{`País emissor${ast}`}</label>
            <input
              value={valor.documentoEstrangeiroPais || ""}
              onChange={(e) => alterar("documentoEstrangeiroPais", limparPaisEstrangeiro(e.target.value))}
              disabled={somenteLeitura}
              maxLength={100}
              placeholder="Ex.: ARGENTINA"
              className={classeCampo}
            />
          </div>
          {mostrarTipoPessoa && (
            <div style={{ flex: "1 1 160px" }}>
              <label>Tipo de pessoa*</label>
              <select
                value={tipoPessoa || ""}
                onChange={(e) => !somenteLeitura && onTipoPessoa?.(e.target.value)}
                disabled={somenteLeitura}
                className={classeCampo}
                style={estiloSelect}
              >
                <option value="" style={estiloOpcao}>
                  Selecione
                </option>
                {opcoesTipoPessoa.map((o) => (
                  <option key={o.valor} value={o.valor} style={estiloOpcao}>
                    {o.label}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

/**
 * Interruptor moderno (toggle) "<Cadastro> estrangeiro" para telas sem MUI,
 * para ficar ao lado do campo de CPF/CNPJ.
 */
export function FlagEstrangeiroHtml({ valor = {}, onChange, somenteLeitura = false, rotulo = "Estrangeiro" }) {
  const id = useId();
  const ligado = Boolean(valor.estrangeiro);
  return (
    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 8, whiteSpace: "nowrap" }}>
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={ligado}
        disabled={somenteLeitura}
        onClick={() => !somenteLeitura && onChange?.("estrangeiro", !ligado)}
        style={{
          position: "relative",
          width: 38,
          minWidth: 38,
          height: 20,
          padding: 0,
          margin: 0,
          border: "none",
          borderRadius: 999,
          cursor: somenteLeitura ? "default" : "pointer",
          backgroundColor: ligado ? "#1998a8" : "var(--ig-f-555555, #9ca3af)",
          opacity: somenteLeitura ? 0.6 : 1,
          transition: "background-color 0.2s",
          flex: "0 0 auto",
        }}
      >
        <span
          style={{
            position: "absolute",
            top: 2,
            left: ligado ? 20 : 2,
            width: 16,
            height: 16,
            borderRadius: "50%",
            backgroundColor: "#fff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.4)",
            transition: "left 0.2s",
          }}
        />
      </button>
      <label htmlFor={id} style={{ margin: 0, display: "inline", fontWeight: 600, cursor: somenteLeitura ? "default" : "pointer" }}>
        {rotulo}
      </label>
    </div>
  );
}
